<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="standard">
        <mat-label>New password</mat-label>
        <input matInput name="password" formControlName="password">
        <mat-error *ngIf="resetPasswordForm.get('password')?.invalid">Password must be at least 6 characters</mat-error>
    </mat-form-field>
    <mat-form-field appearance="standard">
        <mat-label>Confirm new password</mat-label>
        <input matInput name="confirmPassword" formControlName="confirmPassword" [errorStateMatcher]="matcher">
        <mat-error *ngIf="resetPasswordForm.hasError('passwordsDoNotMatch')">Passwords don't match</mat-error>
    </mat-form-field>

    <div class="submit">
        <button mat-raised-button class="cancel-btn" type="button" color="accent" [routerLink]="['login']">Cancel</button>
        <button mat-raised-button class="submit-btn" type="submit" color="accent">Submit</button>
    </div>
</form>